import { usePreference } from '../../Data/Preference';
import { Provider, useSearchContext } from './Provider';
import SearchBar from './SearchBar';


const Search = (props) => {
    const [persistedData, setPersistedData] = usePreference(props.persist ?? 'search');

    const mergedProps = {...props};

    if (props.persist) {
        mergedProps.data = {...(props.data ?? {}), ...persistedData};
        mergedProps.onChange = (d) => {
            setPersistedData(d)
            props.onChange && props.onChange(d);
        };
    }

    return <Provider {...mergedProps}>
        {props.children}
    </Provider>
};

export default Search;

export {
    SearchBar,
    useSearchContext as useSearch,
}
